import styled from "styled-components";

export const RecallWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 2rem;

  @media (max-width: ${({ theme }) => theme.screen.mobile}) {
    padding: 2rem 0.5rem;
  }

  .top-wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
`;

export const ViewRecallWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 2rem;
  max-width: 100%;
  padding: 1rem 2rem;

  @media (max-width: ${({ theme }) => theme.screen.mobile}) {
    padding: 2rem 0.2rem;
  }

  .containerWrapper {
    background-color: white;
    padding: 2rem 3rem;

    .double-column-wrapper {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 2rem;
      margin-top: 1rem;
      margin-bottom: 4rem;
    }

    .regulatoryWrapper {
      margin-bottom: 4rem;

      .regulatoryReason {
        display: flex;
        gap: 10px;
        margin-top: 1rem;
      }
    }

    .cartonWrapper {
      margin-top: 1rem;
      h5 {
        font-weight: 400;
        font-size: 0.85rem;
        color: ${({ theme }) => theme.text.prim_100};
      }
      .cartonContainer {
        .cartonList {
          display: flex;
          align-items: center;
          justify-content: space-between;
          h5 {
            font-weight: 400;
            font-size: 0.85rem;
            color: ${({ theme }) => theme.text.prim_100};
            text-transform: capitalize;
            word-wrap: break-word;
          }

          svg {
            cursor: pointer;
          }
        }
      }
    }

    .paginationWrapper {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-bottom: 10px;
      .paginationController {
        width: 50%;
        display: flex;
        align-items: center;
      }
    }

    .distributorWrapper {
      margin-top: 20px;
      h5 {
        font-weight: 400;
        font-size: 0.85rem;
        color: ${({ theme }) => theme.text.prim_100};
      }

      .distributorContainer {
        margin-top: 30px;
        width: 100;

        .distibutorItem {
          width: 100%;
          display: grid;
          align-items: start;
          h3 {
            font-weight: 600;
            font-size: 0.875rem;
            color: ${({ theme }) => theme.text.prim_100};
          }

          span {
            text-align: right;
            color: ${({ theme }) => theme.text.prim_100};
            font-size: 0.85rem;
            display: block;
          }

          .status {
            text-align: right;
            color: ${({ theme }) => theme.text.prim_100};
            font-size: 0.85rem;
            display: block;
            width: 100%;
            align-items: center;
            justify-content: center;
            gap: 0.5rem;
            padding: 0.6rem 0.6rem;
            border-radius: 0.5rem;
            min-width: 5.9rem;
          }

          .pending {
            /* border: 1px solid orange; 
            background-color: #ffa6001b; */

            .status-dot {
              background-color: orange;
            }
            h3 {
              color: orange;
            }
          }

          .rejected,
          .declined {
            /* border: 1px solid #ff5100; */
            background-color: #ff00001d;
            .status-dot {
              background-color: #ff5100;
            }
            h3 {
              color: #ff5100;
            }
          }

          .recieved,
          .accepted {
            /* border: 1px solid #336cfb; 
            background-color: #336cfb22; */
            .status-dot {
              background-color: #336cfb;
            }
            h3 {
              color: #336cfb;
            }
          }
        }
      }
    }

    .submitWrapper {
      margin-top: 2rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .separate {
    width: 100%;
    height: 1px;
    background-color: ${({ theme }) => theme.bg.prim_300};
    margin-bottom: 1rem;
    margin-top: 1rem;
  }
`;

export const CartonDetails = styled.div`
  width: 45rem;
  background-color: ${({ theme }) => theme.bg.prim_500};
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-width: 100%;

  @media (max-width: ${({ theme }) => theme.screen.mobile}) {
    padding: 2rem 0.5rem;
  }

  h4 {
    font-weight: 600;
    font-size: 0.875rem;
    color: ${({ theme }) => theme.text.prim_100};
    word-wrap: break-word;
  }

  span {
    font-weight: 400;
    font-size: 0.85rem;
    color: ${({ theme }) => theme.text.prim_100};
    text-transform: capitalize;
    word-wrap: break-word;
  }

  .title {
    margin-top: 10px;
  }

  .packWrapper {
    width: 100%;
    display: flex;
    align-items: start;
    justify-content: space-between;
    margin-bottom: 10px;

    .serialWrapper {
      span {
        display: block;
        margin-bottom: 5px;
      }
    }
  }
`;
